export function cleanSectionIds(sectionIds: string[]): string[] {
    return sectionIds.map((id) => {
        if (id.startsWith('product_')) {
            const parts = id.split('_');
            if (parts.length >= 2) {
                return `product_${parts[1]}`;
            }
            return 'product';
        }

        return id;
    });
}
